import React, { useEffect, useState } from 'react';
import { Typography, Divider, Drawer, List, makeStyles, useTheme, useMediaQuery } from '@material-ui/core';
import CategoriesSidebarItem from './CategoriesSidebarItem';
import { useHeaderBottomTracker } from '../../../hooks';
import styles from './CategoriesSidebar.styles';

const useStyles = makeStyles(styles);

const CategoriesSidebar = ({ catalog, activeCategoryId, onSelectedCategory }) => {
  const theme = useTheme();
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));

  const top = useHeaderBottomTracker();

  useEffect(() => {
    setOpen(!isXs);
  }, [isXs]);

  const categoriesList = (
    <List className={classes.list}>
      {catalog.map((category, idx) => (
        <CategoriesSidebarItem
          key={category.id}
          category={category}
          active={category.id === activeCategoryId}
          onClick={() => onSelectedCategory(idx)}
        />
      ))}
    </List>
  );

  return (
    <Drawer
      anchor="left"
      open={open}
      variant="persistent"
      classes={{ paper: classes.root }}
      ModalProps={{
        keepMounted: true // Better open performance on mobile.
      }}
      PaperProps={{ style: { top } }}
    >
      <Typography component="h2" variant="h6" className={classes.header}>
        CATEGORIES
      </Typography>
      <Divider className={classes.divider} />
      {categoriesList}
    </Drawer>
  );
};

export default React.memo(CategoriesSidebar);
